import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Industries } from './pages/Industries';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
export function App() {
  return <Router data-id="element-0" data-mp="2rl6vf6ijosua">
      <Layout data-id="element-1" data-mp="2rit3h6j5vwqy">
        <Routes data-id="element-2" data-mp="2mluairb8hvuc">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mmvnx2fq2uf8" />} data-id="element-3" data-mp="2mmcds7wbdabr" />
          <Route path="/services" element={<Services data-id="element-6" data-mp="31aqfuglwour9" />} data-id="element-5" data-mp="2mnnh66lukg2c" />
          <Route path="/industries" element={<Industries data-id="element-8" data-mp="31c9uk2rwyxqx" />} data-id="element-7" data-mp="31aysc7e49y1x" />
          <Route path="/about" element={<About data-id="element-10" data-mp="2wjgpfdsj9neb" />} data-id="element-9" data-mp="31cjou2jzrr2f" />
          <Route path="/contact" element={<Contact data-id="element-12" data-mp="2whx9xpepbgdl" />} data-id="element-11" data-mp="2wiyv4mpflj91" />
          <Route path="/terms" element={<Terms data-id="element-14" data-mp="28tmej1rry8wp" />} data-id="element-13" data-mp="28ufoebm15ej2" />
          <Route path="/privacy" element={<Privacy data-id="element-16" data-mp="28s2xh8yanttv" />} data-id="element-15" data-mp="28suu8n3mnxlq" />
        </Routes>
      </Layout>
    </Router>;
}